import {vnModule_knockoutJS} from '../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import {articleSessionEdit_template} from '../components/templates/articleSessionEdit_template';
import {XMLHttpRequestHandler, XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;

export class article_session_edit extends vnModule_knockoutJS {

    protected articleSessionEditTemplate : articleSessionEdit_template;
    protected moduleXHRHdl : XMLHttpRequestHandler;


    protected getModuleName(): string {
        return "article_session_edit";
    }

    buildContent(): Array<Element>{
        this.articleSessionEditTemplate = new articleSessionEdit_template('list', this.viewModel, this);

        return [this.articleSessionEditTemplate.build()];
    }

    public fillPage(): void {

        let currentYear = new Date().getFullYear();

        this.articleSessionEditTemplate.setSuccessSelectedYear(currentYear);
        this.articleSessionEditTemplate.setFailureSelectedYear(currentYear);
        this.populateBrandSessionTarget(currentYear);
    }

    public populateBrandSessionTarget(currentYear) {

        if( this.moduleXHRHdl ){
            this.moduleXHRHdl.cancelAndReset();
        }

        this.loadingIn(this.articleSessionEditTemplate.builtTemplate.children.namedItem('session-target-list-results'));

        let usrReq_url: string = '/api/session-target/get/' + currentYear;
        let usrReq_params: Array<Array<string>> = [];

        this.moduleXHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.moduleXHRHdl.onReadyStateFunction = this.onListFormDataRequestReturn;
        this.moduleXHRHdl.execute();
    }

    public onListFormDataRequestReturn(req, obj) {
        return function() {
            obj.manageResponse(req, obj, function(){
                let response = JSON.parse(req.request.response);

                obj.updateList(response.sessionTargetList);
                obj.updateYearList(response.sessionTargetYears, response.year, response.type || 'all');
                obj.updateFallback(response.fallback);
                obj.updateContentTypes(response.contentTypes);
                obj.resetUnsavedBrandSessionTarget();

                obj.loadingOut(obj.articleSessionEditTemplate.builtTemplate.children.namedItem('session-target-list-results'));
            });
        }
    }

    public updateList(sessionTargets) {

        this.articleSessionEditTemplate.setListingSessionTargets(sessionTargets);
    }

    public updateYearList(years, currentYear, type) {

        if (type == 'all' || type == 'success') {
            this.articleSessionEditTemplate.setYearsOnSuccessConfig(years, currentYear);
        }

        if (type == 'all' || type == 'failure') {
            this.articleSessionEditTemplate.setYearsOnFailureConfig(years, currentYear);
        }
    }

    public updateFallback(fallback: number): void {

        this.articleSessionEditTemplate.setFallback(fallback);
    }

    public updateContentTypes(contentTypes): void {

        this.articleSessionEditTemplate.setContentTypes(contentTypes);
    }

    public resetUnsavedBrandSessionTarget(): void {

        this.articleSessionEditTemplate.resetUnsavedBrandSessionTarget();
    }

    /**
     * Dropdown event change
     * @param data
     */
    public filterDropdownOnChange(data) {

        switch (data) {
            case 'yearSelector':
                let hasUnsavedTargetSessions = this.articleSessionEditTemplate.hasUnsavedBrandSessionTarget();
                if (hasUnsavedTargetSessions) {

                    if (confirm('Are you sure you want to cancel? any unsaved change will be lost.')) {
                        this.updateSessionBrandDisplay();
                    }
                } else {

                    this.updateSessionBrandDisplay();
                }
                break;
        }
    }

    /**
     * Save the brand session target values
     */
    public save(): void {
        this.loadingIn(this.articleSessionEditTemplate.builtTemplate.children.namedItem('session-target-list-results'));
        let self = this;

        let formReq_url: string = '/api/session-target/save/';
        let formReq_params: Array<Array<string>> = [];
        let sessionTargetViewModel = JSON.parse(ko.toJSON(this.articleSessionEditTemplate.getViewModelForRequest()));

        formReq_params.push(["data", ko.toJSON(sessionTargetViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {
                if (req.request.readyState == 4) {
                    let response = JSON.parse(req.request.response);
                    if (req.request.status == 200) {
                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Brand session target has been saved');
                        obj.getVnAppZone().showNotificationToModule();
                        obj.articleSessionEditTemplate.clearValidationSessionTargets();
                        obj.articleSessionEditTemplate.redirectToView();
                    }
                    if (req.request.status == 400) {
                        let messages = response.validations.map((v) => {
                            return {field: v.dataField, label: v.label, messages: v.messages};
                        });
                        obj.articleSessionEditTemplate.setValidationSessionTargets(messages);
                        window.scrollTo(0, 0);
                    }
                }

                obj.loadingOut(obj.articleSessionEditTemplate.builtTemplate.children.namedItem('session-target-list-results'));
            }
        });
        XHRHdl.execute();
    }

    public updateSessionBrandDisplay() {
        if( this.moduleXHRHdl ){
            this.moduleXHRHdl.cancelAndReset();
        }

        let selectedYear : string = this.articleSessionEditTemplate.getYearSelector();
        let selectedType : string = this.articleSessionEditTemplate.getSelectedType();
        this.loadingIn(this.articleSessionEditTemplate.builtTemplate.children.namedItem('session-target-list-results'));

        // Make the year Dynamic
        let usrReq_url: string = '/api/session-target/get/' + selectedYear;
        let usrReq_params: Array<Array<string>> = [];

        usrReq_params.push(["data", ko.toJSON({type: selectedType, mode: 'edit'})]);

        this.moduleXHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.moduleXHRHdl.onReadyStateFunction = this.onListFormDataRequestReturn;
        this.moduleXHRHdl.execute();
    }


    public getContentTypes() {
        return this.articleSessionEditTemplate.getContentTypes();
    }

    public getSelectedYear() {
        return this.articleSessionEditTemplate.getSelectedYear();
    }


    saveContentTypesExceptions(data): void {

        if (this.moduleXHRHdl) {
            this.moduleXHRHdl.cancelAndReset();
        }

        this.loadingIn(this.articleSessionEditTemplate.getSavingElement());

        let usrReq_url: string = '/api/session-target/save-content-types-exceptions/' + data.brandId + '/' + data.year + '/';
        let usrReq_params: Array<Array<string>> = [];
        let exceptionsTargetSessions = JSON.parse(ko.toJSON(data));

        usrReq_params.push(["data", ko.toJSON(exceptionsTargetSessions)]);

        this.moduleXHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.moduleXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.moduleXHRHdl.onReadyStateFunction = this.onSaveExceptionsDataRequestReturn;
        this.moduleXHRHdl.execute();
    }

    public onSaveExceptionsDataRequestReturn(req, obj) {

        return function (): void {

            if (req.request.readyState == 4) {

                let response = JSON.parse(req.request.response);
                if (response.status == 400) {
                    let messages = response.validations.map((v) => { return { field: v.dataField, label: v.label, messages: v.messages };});
                    obj.articleSessionEditTemplate.setValidationSessionTargetsExceptions(messages);
                    window.scrollTo(0, 0);
                } else {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Content types session target has been saved');
                    obj.getVnAppZone().showNotificationToModule();
                    obj.articleSessionEditTemplate.insertSessionTargetsExceptions();
                }
                obj.loadingOut(obj.articleSessionEditTemplate.getSavingElement());
            }
        }
    }
}


// WEBPACK FOOTER //
// ./js/modules/article_session_edit.ts